import { OutOfCoreTaskBase } from "./OutOfCoreTaskBase";
import { isPromiseLike } from '../../../../globals';

/** @import { OutOfCoreTileManager } from "../OutOfCoreTileManager" */

/**
 * A task that executes a generic callback
 */
export class CallbackTask extends OutOfCoreTaskBase {

  /**
   *
   * @param {OutOfCoreTileManager} outOfCoreTileManager The OutOfCoreTileManager instance
   * @param {*} callback The callback to be executed
   */
  constructor(outOfCoreTileManager, callback) {
    super(outOfCoreTileManager);

    this.callback = callback;
  }

  execute() {
    const result = this.callback();

    if (isPromiseLike(result)) return result;
  }
}